import * as Yup from 'yup';

export default Yup.object().shape({
  newPassword: Yup.string()
    .matches(/^.*(?=.{12,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
      'Stronger password required')
    .required('Required'),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], 'Must match with password')
    .required('Required'),
});
